<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">
      {{ isJoinOrCreate ? $t('joinOrCreateDesc') : $t('welcomeToTape') }}
    </h2>
    <p slot="desc" v-if="!isJoinOrCreate" class="desc text-center mb-0">{{ $t('welcomeDesc') }}</p>
    <div slot="content" class="content">
      <v-row class="mt-8 pt-8" v-if="invited.length > 0">
        <v-col>
          <v-card elevation="0">
            <v-subheader>{{ $t('invitedWorkspace') }}</v-subheader>
            <v-divider class="mx-3" style="background-color: #96a7af"></v-divider>
            <v-list flat style="max-height: 215px" class="overflow-y-auto pa-0 mt-2">
              <v-list-item v-for="(item, i) in invited" :key="i">
                <v-list-item-icon>
                  <v-avatar
                    :color="(item.wsLogo === undefined ? item.wsName : '') | iconBackground"
                    class="logo"
                    rounded
                    size="35"
                    style="cursor: pointer"
                  >
                    <span class="white--text text-sm-h6 cent" v-if="!item.wsLogo">
                      {{ item.wsName | iconFilter }}
                    </span>
                    <v-img :src="item.wsLogo" v-else />
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-row>
                    <v-col align-self="center">
                      <v-list-item-title v-text="item.wsName"></v-list-item-title>
                    </v-col>
                    <v-col align="right">
                      <font-awesome-icon
                        @click="accept(i, false, item)"
                        style="
                          margin-left: 2px;
                          padding-left: 4px;
                          padding-top: 2px;
                          font-size: 25px;
                          color: #27cd8b;
                          cursor: pointer;
                        "
                        icon="check"
                      />
                      <font-awesome-icon
                        @click="accept(i, true, item)"
                        style="
                          margin-left: 12px;
                          padding-left: 4px;
                          padding-top: 6px;
                          font-size: 27px;
                          color: #ff575f;
                          cursor: pointer;
                        "
                        icon="times"
                      />
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-divider class="mx-3" style="background-color: #666666" v-if="invited.length > 0"></v-divider>
      <v-row class="mt-2" justify="center" style="color: #96a7af" v-if="invited.length > 0"><h4>or</h4></v-row>
      <v-row class="content text-center pb-16 mt-2" :class="invited.length > 0 ? '' : 'mt-16 pt-16'">
        <v-col>
          <v-btn block height="172" elevation="0" color="#3DD598" dark id="createWorkspace" to="/workspace/create">
            {{ $t('createWorkspace') }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn block height="172" elevation="0" color="#3DD598" dark id="joinWorkspace" to="/workspace/join">
            {{ $t('joinWorkspace') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { getInvited, respondInvitation } from '@/services/api'
import { mapGetters } from 'vuex'
import { sendUserTokenToExtension } from '@/services/extension.js'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'Workspace',
  components: {
    Layout,
  },
  data() {
    return {
      invited: [],
      isLoading: false,
      userInfo: this.$store.getters.userInfo,
    }
  },
  methods: {
    async sendUserTokenToExtension() {
      sendUserTokenToExtension(this, this.currentUser)
    },

    async getInvited() {
      try {
        await this.$store.dispatch('setIsLoading', true)
        this.invited = await getInvited(this, this.userInfo.userEmail)
      } catch (error) {
        console.log(error)
        await this.$store.dispatch('setIsLoading', false)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
      }
    },
    async accept(index, refuse, queue) {
      try {
        await this.$store.dispatch('setIsLoading', true)
        let result = await respondInvitation(this, queue.wsId, this.userInfo.userId, queue.inviteId, refuse)
        if (!refuse) {
          localStorage.setItem('lastSelectedWsInfo', JSON.stringify(result))
          await this.$store.dispatch('setSelectedWsInfo', result)
        }
      } catch (error) {
        console.log(error)
        await this.$store.dispatch('setIsLoading', false)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
        if (refuse) {
          this.invited.splice(index, 1)
          // notify(this, 'Success', this.$t('joinWorkspaceComplete'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('joinWorkspaceComplete'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        } else {
          location.reload()
        }
      }
    },
  },
  created() {
    this.getInvited()

    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '워크스페이스 생성/가입',
        firebase_screen_class: 'Workspace',
      },
    })
  },

  mounted() {
    this.sendUserTokenToExtension()
  },

  computed: {
    ...mapGetters(['currentUser']),

    isJoinOrCreate() {
      return this.$store.getters.isJoinOrCreate && this.$store.getters.isJoinOrCreate !== null
        ? this.$store.getters.isJoinOrCreate
        : false
    },
  },
}
</script>

<style scoped>
#createWorkspace >>> span,
#joinWorkspace >>> span {
  color: #fff;
}
#createWorkspace:hover,
#joinWorkspace:hover {
  background-color: #34c589 !important;
  box-shadow: 1px 2px 3px 0 #111 !important;
  transform: translate(-1px, -1px);
}
.content {
  max-width: 450px;
  margin: 0 auto;
}

.content >>> .theme--light {
  background-color: transparent;
  color: white;
}

.content >>> .v-list-item__title {
  color: white;
}
</style>
